// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__r1ty_","placeholdersHeader":"styles_placeholdersHeader__1rxF4","editorStyle":"styles_editorStyle__3cotm","placeholdersBox":"styles_placeholdersBox__2XYDl"};